"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdLaravelFlow = require("cccisd-laravel-flow");
var _style = _interopRequireDefault(require("./style.css"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _useNavigation2 = _interopRequireDefault(require("../../useNavigation.js"));
var _Settings = require("../Settings");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var _default = function _default(props) {
  var mediatorProps = props.mediatorProps,
    isNetworkError = props.isNetworkError;
  var settings = _objectSpread(_objectSpread({}, _Settings.initialValues), mediatorProps);
  var mustTakeInOrder = settings.mustTakeInOrder,
    showTitleInTooltip = settings.showTitleInTooltip;
  var _useNavigation = (0, _useNavigation2["default"])(_objectSpread(_objectSpread({}, props), {}, {
      mustTakeInOrder: mustTakeInOrder
    })),
    navItems = _useNavigation.navItems,
    currentFlowProps = _useNavigation.currentFlowProps,
    isLoading = _useNavigation.isLoading;
  return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.DefaultPlayerSettingsContext.Provider, {
    value: {
      background: 'solidColor',
      backgroundColor: '#fff'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: isLoading
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].nav
  }, navItems.map(function (item) {
    var _classnames;
    var bubble = /*#__PURE__*/_react["default"].createElement("div", {
      key: item.handle,
      className: (0, _classnames2["default"])(_style["default"].item, (_classnames = {}, _defineProperty(_classnames, _style["default"].current, item.isCurrent), _defineProperty(_classnames, _style["default"].allowed, item.isAllowed), _defineProperty(_classnames, _style["default"]["new"], item.isNew), _classnames)),
      onClick: item.setCurrent
    });
    return showTitleInTooltip ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: item.title
      })
    }, bubble) : bubble;
  })), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelFlow.Player, _extends({
    key: currentFlowProps.handle
  }, currentFlowProps, {
    isNetworkError: isNetworkError
  }))));
};
exports["default"] = _default;